import { OPERATOR_LT_EQUALS } from '@atlaskit/jql-ast';
import type { IntlShape } from '@atlassian/jira-intl';
import type { JqlData, JqlInfo } from '@atlassian/jira-jql-utils/src/utils/types.tsx';
import type { TypeConfig, DateTimeValue } from '../../common/types.tsx';
import messages from './messages.tsx';

export const NOW_OVERDUE_CONFIG: TypeConfig = {
	type: 'now_overdue',
	componentType: 'is_not_set',
	label: 'labelNowOverdue',
	hasInput: false,
	getFormattedValue: (intl: IntlShape, value?: DateTimeValue): string =>
		value ? intl.formatMessage(messages.valueNowOverdue) : '',
	getJqlData: () => ({
		primaryClause: {
			operator: OPERATOR_LT_EQUALS,
			operand: '0',
		},
	}),
	getValueFromJqlData: (jqlData?: JqlData): DateTimeValue | undefined => {
		if (jqlData !== undefined) {
			const { primaryClause, secondaryClause } = jqlData;
			if (primaryClause !== undefined && secondaryClause !== undefined) {
				// Does not match type if more than one clause is present
				return undefined;
			}
			const clause: JqlInfo | undefined = primaryClause || secondaryClause;
			if (clause && clause.operator === OPERATOR_LT_EQUALS) {
				const value = clause.operand;
				if (value && (value === '0' || value === '"0"')) {
					return { value1: '', value2: '' };
				}
			}
		}
		return undefined;
	},
};
